import { useUser } from '@work4all/data';

import { canConvertDeliveryNote } from '@work4all/utils/lib/permissions';

import { usePermissionsRights } from './use-permissions-rights';

export const useCanCloneDeliveryNote = () => {
  const user = useUser();
  const { isErpLightUser, isFullLicenceUser } = usePermissionsRights();

  return (isErpLightUser || isFullLicenceUser) && canConvertDeliveryNote(user);
};
